import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Status({ tone, alert, live, className, children, ...rest }) {
    return (_jsxs("span", { className: cn("fwfa-status", alert && "fwfa-status--alert", live && "fwfa-status--live", className), "data-tone": tone, "data-live": live ? "true" : undefined, ...rest, children: [_jsx("span", { className: "fwfa-status-dot" }), children] }));
}
//# sourceMappingURL=Status.js.map